import { gql } from '@efficiently/client-core-graphql-models';

export const REMOVE_BACKGROUND = gql(`
	mutation RemoveBackground(
		$file: Upload!
		$size: ImageSize
		$type: ImageType
		$format: ImageFormat
		$scale: String
		$position: String
		$crop: Boolean
		$cropMargin: String
		$roi: String
		$backgroundColor: String
		$backgroundImageUrl: String
		$channels: ImageChannels
		$addShadow: Boolean
		$contentId: String
	) {
		removeBackground(
			file: $file
			size: $size
			type: $type
			format: $format
			scale: $scale
			position: $position
			crop: $crop
			cropMargin: $cropMargin
			roi: $roi
			backgroundColor: $backgroundColor
			backgroundImageUrl: $backgroundImageUrl
			channels: $channels
			addShadow: $addShadow
			contentId: $contentId
		) {
			base64img
		}
	}
`);
